const React = require("react");

const withState = require("../../../../../utils/withState");
const {mobile$} = require("../../../../../emitters/mobile");

const DesktopView = require("./components/DesktopView");
const MobileView = require("./components/MobileView");

const IntervalFilter = () => {
  return (state, props) => {

    const Main = state.mobile
      ? MobileView
      : DesktopView;

    return <Main {...props} />;
  }
};

module.exports = withState(IntervalFilter, {mobile: mobile$});
